import { useState, useEffect } from "react";
import { loadStripe } from "@stripe/stripe-js";
import { Button } from "@mui/material";
import axios from "axios";
import "../styles/cart.scss";
import Nav from "../Nav";
import { TextField, Alert, FormControlLabel, Checkbox } from "@mui/material";
import {
  EmbeddedCheckoutProvider,
  EmbeddedCheckout,
} from "@stripe/react-stripe-js";
const stripePromise = await loadStripe("pk_live_aRr3qYrpVTbyNgBbB7t0jqiy");
// const stripePromise = await loadStripe("pk_test_HGDc5rMpzlE4NJvFygwF1zIW");
//TEST PRICE KEYS
const price_ftb_test = "";
const price_ldc_test = "";
const price_both_test = "";
//LIVE PRICE KEYS
const price_ftb_live = "";
const price_ldc_live = "";
const price_both_live = "";

export default function Cart() {
  // const url = "http://localhost:3999";
  const url = "https://dev.pmwwebdesign.com";
  const [tcs, setTcs] = useState(false);
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [options, setOptions] = useState({});
  const [showPayment, setShowPayment] = useState(false);
  const [product, setProduct] = useState(null);
  // alerts
  const [message, setMessage] = useState("");
  const [severity, setSeverity] = useState("");
  const [alert, setAlert] = useState(false);
  const [disabled, setDisabled] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    let product = params.get("prod");
    let _product = {};
    if (product === "bundle") {
      _product = {
        price: price_both_test,
        description: "Fast Track Bundle & Land Development Course",
      };
    } else if (product === "fast-track") {
      _product = {
        amount: price_ftb_test,
        description: "Fast Track Bundle",
      };
    } else if (product === "land-development") {
      _product = {
        amount: price_ldc_test,
        description: "Land Development Course",
      };
    }
    console.log(_product);
    setProduct(_product);
  }, []);

  const handleAlert = (message, severity, duration = 3000) => {
    setDisabled(true);
    setMessage(message);
    setSeverity(severity);
    setAlert(true);
    setTimeout(() => {
      setAlert(false);
      setMessage("");
      setSeverity("");
      setDisabled(false);
    }, duration);
  };

  const detailsValidation = () => {
    const emailRegex = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;
    const phoneRegex = /^\+?[0-9]{1}[0-9\s\-\(\)]{3,23}$/;
    if (firstName === "" || lastName === "" || phone === "" || email === "") {
      handleAlert("All fields are required", "warning");
    } else if (email === "" || !email.match(emailRegex)) {
      handleAlert("Please enter a valid email", "warning");
    } else if (phone == "" || !phone.match(phoneRegex)) {
      handleAlert("Please enter a valid phone number", "warning");
    } else if (!tcs) {
      handleAlert("Please read and tick the terms & conditions", "warning");
    } else {
      createCart();
    }
  };

  const createCart = async () => {
    let reqBody = {
      firstName: firstName,
      lastName: lastName,
      email: email,
      phone: phone,
      product: product,
    };
    console.log(reqBody);

    await axios
      .post(`${url}/property/create-fast-track-cart`, reqBody)
      .then((res) => {
        setOptions({ clientSecret: res.data.client_secret });
        setShowPayment(true);
      })
      .catch((err) => {
        console.log(err);
        handleAlert("Something went wrong - please try again", "error");
      });
    // await axios
    //   .post(`${url}/property/ft-abandoned-cart`, reqBody)
    //   .then((res) => {
    //     localStorage.setItem("ftClient", JSON.stringify(reqBody));
    //     setShowPayment(true);
    //   })
    //   .catch((err) => {
    //     console.log(err);
    //     handleAlert("something went wrong, please try again", "error");
    //   });
  };

  return (
    <main className="cart">
      <Nav />
      {!showPayment ? (
        <section className="form">
          <h2>Please Insert Your Details</h2>
          <section className="form__row">
            <TextField
              id="outlined-basic"
              label="First Name"
              variant="outlined"
              className="field"
              onChange={(e) => setFirstName(e.target.value)}
              required
            />
            <TextField
              id="outlined-basic"
              label="Last Name"
              variant="outlined"
              className="field"
              onChange={(e) => setLastName(e.target.value)}
              required
            />
          </section>
          <section className="form__row">
            <TextField
              id="outlined-basic"
              label="Email"
              variant="outlined"
              className="field"
              onChange={(e) => setEmail(e.target.value)}
              required
            />
            <TextField
              id="outlined-basic"
              label="Phone Number"
              variant="outlined"
              className="field"
              onChange={(e) => setPhone(e.target.value)}
              pattern="[0-9]*"
              required
            />
          </section>
          <FormControlLabel
            control={<Checkbox />}
            label="I confirm I have read and agree to the terms & conditions"
            onChange={() => setTcs(!tcs)}
          />

          {alert ? (
            <Alert severity={severity} width="80%" sx={{ margin: "3% auto" }}>
              {message}
            </Alert>
          ) : null}
          <Button onClick={detailsValidation} disabled={disabled}>
            Payment Details
          </Button>
        </section>
      ) : (
        <EmbeddedCheckoutProvider stripe={stripePromise} options={options}>
          <EmbeddedCheckout />
        </EmbeddedCheckoutProvider>
      )}
    </main>
  );
}
